module.exports = __webpack_public_path__ + "static/media/crisi-aziendale.4999fb3a.jpg";